<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title"> </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button> -->

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <!-- <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        <TheSelect id="" title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th class="col80">Lĩnh vực</th>
                                <th>Trạng thái</th>
                                <th>Ngày ghi nhận</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="item.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.typeName }}</td>
                                <td>
                                    <span v-if="item.isExecuted" class="badge badge-success">Đã thực thi</span>
                                    <span v-else class="badge badge-danger">Không thực thi</span>
                                </td>
                                <td>{{ item.dateStr }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <!-- <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import { userModel } from '@/models/user.model.js'
import config from '@/config/prod.env';
import common from '@/helper/common.js';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';

export default {
    components: {
        // paginate: Paginate,
        loading: Loading,
        // TheSelect
    },
    name: "ThePentahoJobRunInday",
    data() {
        return {
            isBusy: false,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "date",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,

            roles: [],

            // model 
            model: userModel.newModel(),

            selectedId: '',
            newPass: "",

            title: "",
            code: "",
            styleButton: "",
            // For mesage validate
            errors: {},
            submitted: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('pentahoLog', ['getAllJobRunIndayPaging']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Danh sách job thực thi trong ngày'
            this.setupHeader({ header })
        },

        // ------ get data datatable ------
        async getData() {

            // state for loading overlay
            this.isBusy = true;
            // Set param for paging
            let params = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchKey: this.filter
            };
            // Call get data
            let rs2 = await this.getAllJobRunIndayPaging(params);
            if(rs2.isOk) {
                // List data
                this.items = rs2.data.data;
                // Total row
                this.totalRow = rs2.data.totalRow;
                // Number show
                this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
                // For export excel
                this.exportDatas = this.items.map(({ rowNumber, id, username, fullname, email, phoneNumber }) => ({
                    rowNumber, id, username, fullname, email, phoneNumber
                }));
            }
            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },
        
    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
    },
    async created() {

    }
}
</script>

<style>

</style>
